import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

export interface DisclosureStateInterface {
  dnd: boolean; // add sidebar for toggle use only
  protectedRoute: Record<string, number>;
  cityLedger: boolean;
  posShiftAlert: boolean;
}
export type ButtonName = 'dnd' | 'cityLedger' | 'posShiftAlert'; // add sidebar for toggle use only

const initialState: DisclosureStateInterface = {
  dnd: false,
  cityLedger: false,
  posShiftAlert: false,
  protectedRoute: {},
  // add sidebar for toggle use only
};

export const DisclosureSlice = createSlice({
  name: 'disclosure',
  initialState,
  reducers: {
    setProtectedRoute: (state, action: PayloadAction<string>) => {
      if (
        !state.protectedRoute ||
        typeof state.protectedRoute !== 'object' ||
        Array.isArray(state.protectedRoute)
      ) {
        state.protectedRoute = {};
      }

      state.protectedRoute[action.payload] = moment().add(1, 'hour').valueOf();
    },
    resetProtectedRoute: (state) => {
      state.protectedRoute = {};
    },
    onOpen: (state, action: PayloadAction<ButtonName>) => {
      state[action.payload] = true;
    },
    onClose: (state, action: PayloadAction<ButtonName>) => {
      state[action.payload] = false;
    },
    onToggle: (state, action: PayloadAction<ButtonName>) => {
      state[action.payload] = !state[action.payload];
    },
    reset: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export default DisclosureSlice.reducer;

// Add all of the reducers to the export below
export const {
  onOpen,
  onClose,
  onToggle,
  reset,
  setProtectedRoute,
  resetProtectedRoute,
} = DisclosureSlice.actions;
